import { GetStaticProps, GetStaticPaths } from 'next';

import Layout, { DocsLayoutProps } from '@/components/Layout/Docs';
import { getPagePath } from '@/lib/mdx';
import { allGuides } from 'contentlayer/generated';
import type { Guide } from 'contentlayer/generated';

interface GuideProps extends DocsLayoutProps {
  doc: Guide;
}

export default function GuidePage({ doc }: GuideProps) {
  return <Layout doc={doc} />;
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const pagePath = getPagePath({
    slug: ctx?.params?.slug,
    categoryPath: `guides`,
  });

  const doc = allGuides.find((doc) => doc._raw.flattenedPath === pagePath);

  return { props: { doc } };
};

export const getStaticPaths: GetStaticPaths = () => ({
  paths: allGuides.map((_) => `/docs/${_._raw.flattenedPath}`),
  fallback: false,
});
